import React, { useEffect, useState } from 'react';
import OrderService from '../../../services/orders/order';
import moment from 'moment';
import styles from './styles.module.scss';

export interface DelayedShipmentItem {
    id: string;
    code: string;
    dateFormatted: string; // e.g. "21/07 21:00"
    isCritical?: boolean;
    link?: string;
}

interface IDelayedShipmentsWidgetProps {
    delayedCount?: number;
    etaNearCount?: number;
    shipments?: DelayedShipmentItem[];
}

const DelayedShipmentsWidget: React.FC<IDelayedShipmentsWidgetProps> = ({
    delayedCount: initialDelayedCount = 0,
    etaNearCount = 0,
    shipments: initialShipments,
}) => {
    const [shipments, setShipments] = useState<DelayedShipmentItem[]>(initialShipments || []);
    const [delayedCount, setDelayedCount] = useState<number>(initialDelayedCount);

    useEffect(() => {
        const fetchDelayedShipments = async () => {
            try {
                const res = await OrderService.retrieve('top=10');
                if (res && res.data && res.data.length > 0) {
                    setDelayedCount(res.data.length);
                    const mapped: DelayedShipmentItem[] = res.data.slice(0, 6).map((order: any) => {
                        const codeStr = order.orderNumber ? `#${OrderService.getOrderNumber(order.orderNumber)}` : order.id;
                        const dateStr = order.createdAt ? moment(order.createdAt).format('DD/MM HH:mm') : '-';

                        return {
                            id: order.id,
                            code: codeStr,
                            dateFormatted: dateStr,
                            link: `/orders/${order.id}`
                        };
                    });
                    setShipments(mapped);
                }
            } catch (e) {
                console.error('Failed to fetch delayed shipments for widget', e);
            }
        };

        fetchDelayedShipments();
    }, []);

    return (
        <div className={styles.container}>
            <h2 className={styles.widgetTitle}>Shipment terlambat / berisiko</h2>

            <div className={styles.counterRow}>
                <div className={`${styles.counterBox} ${styles.redBox}`}>
                    <span className={styles.num}>{delayedCount || shipments.length}</span>
                    <span className={styles.label}>Terlambat</span>
                </div>
                <div className={`${styles.counterBox} ${styles.yellowBox}`}>
                    <span className={styles.num}>{etaNearCount}</span>
                    <span className={styles.label}>ETA &le; 48 jam</span>
                </div>
            </div>

            <div className={styles.shipmentList}>
                {shipments.map((item) => (
                    <a
                        key={item.id || item.code}
                        href={item.link || `/orders/${item.id}`}
                        className={styles.shipmentItem}
                    >
                        <span className={styles.orderCode}>{item.code}</span>
                        <span className={styles.timeInfo}>{item.dateFormatted}</span>
                    </a>
                ))}
            </div>
        </div>
    );
};

export default DelayedShipmentsWidget;
